'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { buttonVariants } from '@/components/ui/button'

export default function NotFound() {
  const t = useTranslations('notFound')
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 p-8 text-center">
      <p>{t('code')}</p>
      <h1 className="text-4xl font-bold">{t('title')}</h1>
      <p>{t('description')}</p>
      <Link href="/" className={buttonVariants()}>
        {t('backHome')}
      </Link>
    </main>
  )
}
